import React from 'react';

import { View } from '@react-pdf/renderer';
import { IGeneralInfoData, InfoTableRow } from 'PDF/components/InfoTableWithIcons/InfoTableRow';

interface IGeneralCompanyInformationTableProps {
  data: IGeneralInfoData[];
}

export const GeneralCompanyInformationTable: React.FC<IGeneralCompanyInformationTableProps> = ({ data }) => {
  return (
    <View style={{ marginBottom: 28 }}>
      {data.map((item, index) =>
        item.info ? <InfoTableRow key={index} data={item} isFirst={index === 0} showBullets={false} /> : null,
      )}
    </View>
  );
};
